<ng-template [vbCssRules]="themeStyleOverrides"></ng-template>
<branding-banner-image [class]="styles.banner"></branding-banner-image>
<div [ngClass]="styles.authShell" class="theme-header-bg theme-header-txt">
	<div [ngClass]="[styles.content, isLargeContent ? styles.authLargeContent : '']">
		<ng-content></ng-content>
	</div>
</div>